export class WebPointLight {
}
